import { Controller } from "stimulus";
import toastr from 'toastr';

export default class extends Controller {
  connect() {
    const messages = JSON.parse(this.element.dataset.messages || "[]")
    if(messages.length < 1) return
    for(let i=0; i < messages.length; i++) {
      const messageType = messages[i][0];
      const message = messages[i][1];
      switch(messageType) {
        case "notice":
          toastr.success(message);
          break;
        default:
          console.log("undefined toastr type.")
          break;
      }
    }
  }
}
